//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { legalHubArticleTypeIconsByLabel } from '~/utils/constants'

export default {
  props: {
    // Storyblok story object
    resource: {
      type: Object,
      required: true,
    },
    showDescription: {
      type: Boolean,
      default: true,
    },
    showUpdatedAt: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      legalHubArticleTypeIconsByLabel,
    }
  },
}

